$(function () {
    let isFormChanged = false;
    let isNextButtonClicked = false;

    // 入力変更を検知
    $('input, textarea, select').on('change keyup', function () {
      isFormChanged = true;
    });

    // 「次へ」ボタンが押されたら確認をスキップ
    $('#register-input').on('click', function () {
      isNextButtonClicked = true;
    });


    // ページ離脱時に確認メッセージ
    $(window).on('beforeunload', function (e) {
      if (isFormChanged && !isNextButtonClicked) {
        e.preventDefault();
        e.returnValue = true;
      }
    });

    // フォーム送信時には確認しないように
    $('form').on('submit', function () {
      isFormChanged = false;
    });
});

$(document).ready(function () {
    $(window).on('pageshow', function () {
        $('form button[type="submit"]')
            .prop("disabled", false)
            .removeClass("inactive");
    });

    $('.back-button').on("click", function (e) {
        if (!confirm(MSG_BACK_CONFIRM)) {
            e.preventDefault();
            return;
        }
        window.location.href = ROUTE_BACK;
    });

    const CONSULT_WITH_AN_EXPERT = 201;
    $('select[name="application_type"]').on("change", function () {
        let applicationType = $(this).val();

        $('#consultation_type').toggle(applicationType == CONSULT_WITH_AN_EXPERT);
        $.ajax({
            url: urlGetApplicationDetail,
            type: "GET",
            data: {
                application_type: applicationType,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (data) {
                if (data.application_detail == "error") {
                    window.location.href = urlErrorGM0000;
                    return;
                }
                $('textarea[name="contact_note"]').val(data.application_detail);
                $('input[name="contact_note_master"]').val(
                    data.application_detail
                );
            },
            error: function (xhr, status, error) {
                window.location.href = urlErrorGM0000;
            },
        });
    });

    function getPreferredDatetime(namePrefix, isInit = false) {
        if (isInit) {
            var date = $(`input[name="final_preferred_at${namePrefix}"]`).val();
            var timeCode = $(`input[name="final_preferred_time_code${namePrefix}"]`).val();
        } else {
            var date = $(`input[name="preferred_at${namePrefix}"]`).val();
            var timeCode = $(`input[name="preferred_time_code${namePrefix}"]:checked`).val();
        }

        var timeText = getCheckboxTextByValue(namePrefix, timeCode);
        return { date, timeText };
    }

    function getCheckboxTextByValue(namePrefix, value) {
        const $checkbox = $(`input[name="preferred_time_code${namePrefix}"][value="${value}"]`);
        if ($checkbox.length === 0) {
            return '';
        }
        return $checkbox.closest('.radio-parent')
                .find('.radio-label')
                .text().trim();
    }


    function setPreferredDatetimeContent(namePrefix, containerSelector, isInit = false) {
        const { date, timeText } = getPreferredDatetime(namePrefix, isInit);

        const $container = $(containerSelector);
        const $content = $container.find('.datetime-content');

        if (date && timeText) {
            var formattedDate = new Date(date);
            // Format to "YYYY年M月D日"
            formattedDate = `${formattedDate.getFullYear()}年${formattedDate.getMonth() + 1}月${formattedDate.getDate()}日`;
            $content.text(`${formattedDate} ${timeText}`);
            $container.removeClass('d-none');
        } else {
            $container.addClass('d-none');
            $content.text('');
        }
    }

    function validatePreferredDatetime(namePrefix, errorDate, errorTime, errorSame) {
        const { date, timeText } = getPreferredDatetime(namePrefix);
        const $dateInput = $(`input[name="preferred_at${namePrefix}"]`);
        const $timeInput = $(`input[name="preferred_time_code${namePrefix}"]`);

        let isValid = true;
        if (!date) {
            $dateInput.closest('.form-group-input').addClass('has-danger');
            $dateInput.closest('.group-input').after(`<p class="text-error">${errorDate}</p>`);
            isValid = false;
        }
        if (!timeText) {
            $timeInput.closest('.form-group-input').addClass('has-danger');
            $timeInput.closest('.group-input').after(`<p class="text-error">${errorTime}</p>`);
            isValid = false;
        }

        // 第1希望日時と第2希望日時の重複チェック
        if (isValid) {
            const firstDate = $(`input[name="preferred_at1"]`).val();
            const firstTime = $(`input[name="preferred_time_code1"]:checked`).val();
            const secondDate = $(`input[name="preferred_at2"]`).val();
            const secondTime = $(`input[name="preferred_time_code2"]:checked`).val();

            if (firstDate === secondDate && firstTime === secondTime) {
                $dateInput.closest('.form-group-input').addClass('has-danger');
                $dateInput.closest('.group-input').after(`<p class="text-error">${errorSame}</p>`);
                isValid = false;
            }
        }

        return isValid;
    }

    function generateContentDatetime() {
        setPreferredDatetimeContent('1', '.first-preferred-datetime-content', true);
        setPreferredDatetimeContent('2', '.second-preferred-datetime-content', true);
    }

    function setValueToInputHidden(name) {
        const $input = $(`input[name="final_${name}"]`);
        const value = $(`input[name="${name}"]`).val();
        if ($input.length) {
            $input.val(value);
        }
    }

    function setCheckedValueToInputHidden(name) {
        const $input = $(`input[name="final_${name}"]`);
        const value = $(`input[name="${name}"]:checked`).val();
        if ($input.length) {
            $input.val(value);
        }
    }

    $('#preMeetingDatetimeModal').on('click', '.pre-meeting-datetime-button', function () {
        $('#preMeetingDatetimeModal').find('.text-error').remove();
        $('.form-group-input').removeClass('has-danger');

        const isValid = validatePreferredDatetime('1', ERR0102_DATE, ERR0102_TIME, ERR0826_SAME);

        const $error = $('#preMeetingDatetimeModal').find('.text-error').first();
        if ($error.length) {
            const $target = $error.prev('.group-input');
            if ($target.length) {
                const $scrollContainer = $('#preMeetingDatetimeModal');

                const targetOffsetTop = $target.offset().top;
                const containerOffsetTop = $scrollContainer.offset().top;
                const scrollTop = $scrollContainer.scrollTop();

                const offset = targetOffsetTop - containerOffsetTop + scrollTop - 20;

                $scrollContainer.animate({
                    scrollTop: offset
                }, 500);
            }
        }

        if (!isValid) return;

        setPreferredDatetimeContent('1', '.first-preferred-datetime-content');
        setPreferredDatetimeContent('2', '.second-preferred-datetime-content');

        setValueToInputHidden('preferred_at1');
        setValueToInputHidden('preferred_at2');
        setCheckedValueToInputHidden('preferred_time_code1');
        setCheckedValueToInputHidden('preferred_time_code2');

        $('.preferred-date-time').find('.text-error').remove();

        $('#preMeetingDatetimeModal').modal('hide');
    });

    // Init
    generateContentDatetime();

    $('.datetimepicker-component').on('focus', function () {
        $(this).trigger('blur');
    });

    var currentFocusedInput = null;
    $(document).on('focus', 'input.hasDatepicker', function () {
        currentFocusedInput = $(this);
    });

    $('#preMeetingDatetimeModal').on('scroll', function () {
        const $datepicker = $('.ui-datepicker:visible');
        if ($datepicker.length && currentFocusedInput) {
            const offset = currentFocusedInput.offset();
            const height = currentFocusedInput.outerHeight();
    
            $datepicker.css({
                top: offset.top + height,
                left: offset.left,
                position: 'absolute',
            });
        }
    });
    
});
